import { Box, Indent, Space } from "@stenajs-webui/core";
import { Label } from "@stenajs-webui/elements";
import * as React from "react";
import { FormulaTypeSelect } from "@/components/data-driven-inputs/selects/formula-type-select/FormulaTypeSelect";
import { FormulaFormInputs } from "./FormulaFormInputs";
import {
  FormulaFormInputsQuery,
  HeadAgreementStatusCode,
  RouteAgreementDetailsStateFragment,
} from "@/gql/graphql";

interface Props {
  articleTypeId: string;
  formulaTypeId?: string;
  articleId: string;
  onChangeFormulaTypeId: (formulaTypeId: string | undefined) => void;
  formulaType:
    | FormulaFormInputsQuery["productPrice"]["formula"]["byId"]
    | null
    | undefined;
  routeAgreement: RouteAgreementDetailsStateFragment;
}

export const FormulaPane: React.FC<Props> = ({
  articleTypeId,
  formulaTypeId,
  articleId,
  onChangeFormulaTypeId,
  formulaType,
  routeAgreement,
}) => {
  return (
    <>
      <Indent num={0}>
        <Label text={"Select formula"}>
          <Box width={"280px"}>
            <FormulaTypeSelect
              isDisabled={
                routeAgreement.statusCode === HeadAgreementStatusCode.Active
              }
              value={formulaTypeId}
              onValueChange={onChangeFormulaTypeId}
            />
          </Box>
        </Label>

        <Space num={2} />

        {formulaTypeId && formulaType && (
          <>
            <FormulaFormInputs
              articleTypeId={articleTypeId}
              articleId={articleId}
              formulaType={formulaType}
            />
          </>
        )}
      </Indent>
    </>
  );
};
